var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pin-code-input",
      class: { "pin-code-input--disabled": _vm.disabled },
    },
    _vm._l(6, function (index) {
      return _c("input", {
        key: index - 1,
        ref: "box" + (index - 1),
        refInFor: true,
        staticClass: "pin-code-input__box",
        class: {
          "pin-code-input__box--filled": _vm.boxes[index - 1] !== "",
          "pin-code-input__box--active": _vm.activeIndex === index - 1,
        },
        attrs: {
          type: "text",
          inputmode: "numeric",
          pattern: "[0-9]*",
          autocomplete: "one-time-code",
          maxlength: "1",
          disabled: _vm.disabled,
          "aria-label": _vm.boxAriaLabel(index - 1),
        },
        domProps: { value: _vm.boxes[index - 1] },
        on: {
          input: function ($event) {
            _vm.onBoxInput($event, index - 1)
          },
          keydown: function ($event) {
            _vm.onBoxKeydown($event, index - 1)
          },
          paste: function ($event) {
            $event.preventDefault()
            _vm.onPaste($event, index - 1)
          },
          focus: function ($event) {
            _vm.activeIndex = index - 1
          },
          blur: function ($event) {
            _vm.onBoxBlur(index - 1)
          },
        },
      })
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }